import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import { QueryClientProvider } from '@tanstack/react-query';

import './App.css';
import { queryClient } from './api';
import WidgetMessages from './app/widgetMessages';
import MainLoader from './components/Loader';
import WidgetModal from './components/WidgetModal';
import WidgetWrapper from './components/WidgetWrapper';
import './i18n';
import WidgetRouter from './infrastructure/router/WidgetRouter';
import d1Theme from './infrastructure/theme';
import useTravelOneWidget from './infrastructure/widgetHooks/useTravelNowWidget';
import { onMsg } from './utils/postMessage';
import { ConsentProvider } from './infrastructure/consent/consentManager';
import { ConsentDialog } from './components/ConsentDialog';

function App() {
  const { showModal, isLoadingModalState } = useTravelOneWidget(queryClient);

  return isLoadingModalState ? (
    <MainLoader />
  ) : (
    showModal && (
      <ConsentProvider>
        <MantineProvider theme={d1Theme}>
          <WidgetWrapper>
            <QueryClientProvider client={queryClient}>
              <WidgetModal
                onDismiss={() => {
                  onMsg(WidgetMessages.DISMISS, '*');
                }}
              >
                <WidgetRouter />
                <ConsentDialog />
              </WidgetModal>
            </QueryClientProvider>
          </WidgetWrapper>
        </MantineProvider>
      </ConsentProvider>
    )
  );
}

export default App;
